import { render, staticRenderFns } from "./BroadcastForm.vue?vue&type=template&id=1dd2a826&scoped=true&"
import script from "./BroadcastForm.vue?vue&type=script&lang=ts&"
export * from "./BroadcastForm.vue?vue&type=script&lang=ts&"
import style0 from "./BroadcastForm.vue?vue&type=style&index=0&id=1dd2a826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd2a826",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
